import { isAxiosError } from 'axios';
import apiClient from './meta-client';

export interface AppPageGroupPage {
    page_id: string;
    page_name: string | null;
    created_at: string | null;
}

export interface PageWithoutToken {
    page_id: string;
    page_name: string | null;
}

/**
 * Erro estruturado que a API devolve quando alguma página não tem token
 * ativo para o app escolhido (PUT /meta/app-page-groups, 422,
 * detail.code === "pages_without_token") — carrega page_id + page_name de
 * cada página problemática em vez de só uma string com IDs crus.
 */
export function extractPagesWithoutToken(error: unknown): PageWithoutToken[] | null {
    if (!isAxiosError(error)) return null;
    const detail = error.response?.data?.detail;
    if (detail && typeof detail === 'object' && detail.code === 'pages_without_token') {
        return detail.pages as PageWithoutToken[];
    }
    return null;
}

export interface AppPageGroup {
    app_id: number;
    app_name: string | null;
    meta_app_id: string | null;
    pages: AppPageGroupPage[];
}

export interface SaveAppPageGroupInput {
    app_id: number;
    page_ids: string[];
}

export async function listAppPageGroups(): Promise<AppPageGroup[]> {
    const response = await apiClient.get<AppPageGroup[]>('/meta/app-page-groups');
    return response.data;
}

export async function saveAppPageGroup(data: SaveAppPageGroupInput): Promise<{ app_id: number; page_ids: string[] }> {
    const response = await apiClient.put('/meta/app-page-groups', data);
    return response.data;
}

export async function deleteAppPageGroup(appId: number): Promise<void> {
    await apiClient.delete(`/meta/app-page-groups/${appId}`);
}

export async function removePageFromGroup(pageId: string): Promise<void> {
    await apiClient.delete(`/meta/app-page-groups/pages/${pageId}`);
}
